import { useState, useRef, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./paybill.scss";

import Header from "../../components/header/header";
import { walletAmount } from "../../store/wallet/walletSlice";
import GetBestOffer from "../../services/GetBestOffer/GetBestOffer";
import Loader from "../../components/loader/loader";
import OfferCard from "../../components/offer-card/offer-card";
import OfferPopUp from "../../components/offer-dialog/offer-dialog";
import RestoDetail from "../../components/resto-detail/resto-detail";
import { pageUrl } from "../../utils/pageConstant";
import CurrencyInput from 'react-currency-input-field';
import { updateHeaders } from "../../services/apiConstants";
import GetWalletPointsAPI from "../../services/GetWalletPoints/GetWalletPoints";
import UserTraction from "../../services/UserTraction/UserTraction";
import GetDineInOutletDetailAPI from "../../services/GetDineInOutletsDetail/GetDineInOutletsDetail";

const BillAmount = () => {
  const { outletId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const amtInput = useRef(null)
  const fromPage = sessionStorage.getItem("payBillSource") || "";

  const [offerDetail, setOfferDetail] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [isOfferDetailOpen, setIsOfferDetailOpen] = useState(false);
  const [modalOffer, setModalOffer] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [outletDetails, setOutletDetails] = useState(null);
  const [walletPoints, setWalletPoints] = useState();
  const [isWalletUpdated, setIsWalletUpdated] = useState(false);

  // const cashback = useSelector((state) => state.wallet.coins);

  useEffect(() => {
    // Handle token + promoCode parsing first
    const initFromUrl = () => {
      const urlTokenParams = searchParams.get("token");
      // if (urlTokenParams) {
      //   let [tokenOnly, promoCode] = urlTokenParams.split('/');
      //   sessionStorage.setItem("token", tokenOnly);
      //   updateHeaders(tokenOnly);
      //   if (promoCode) {
      //     sessionStorage.setItem("promoOutletID", outletId);
      //     sessionStorage.setItem("promoCode", promoCode);
      //   }
      // }

      let tokenOnly = "";
      let promoCode = null;
      let defaultPWA = "";

      if (urlTokenParams) {
        const parts = urlTokenParams.split('/');

        tokenOnly = parts[0];
        
        // Check if second part exists
        if (parts[1]) {
          if (parts[1].startsWith("default")) {
            defaultPWA = parts[1];
          } else {
            promoCode = parts[1];
          }
        }

        // If there's a third part, it will always be defaultPWA
        if (parts[2]) {
          defaultPWA = parts[2];
        }

        sessionStorage.setItem("token", tokenOnly);
        sessionStorage.setItem("defaultPWA", defaultPWA);
        updateHeaders(tokenOnly);

        if (promoCode) {
          sessionStorage.setItem("promoOutletID", outletId);
          sessionStorage.setItem("promoCode", promoCode);
        }
      }
    };
  
    initFromUrl();
  }, [searchParams]);
  
  useEffect(() => {
    const fetchOutletDetails = async () => {
      try {
        const token = sessionStorage.getItem("token"); // Ensure token is available
        if (!token) {
          console.warn("Token not available yet, skipping outlet fetch");
          return;
        }
  
        const response = await GetDineInOutletDetailAPI({
          outletId: outletId || undefined,
          outletNo: undefined,
        });
  
        if (response && response[0]) {
          localStorage.setItem("outletDetailsInfo", JSON.stringify(response[0]));
          setOutletDetails(response[0]);
        }
      } catch (e) {
        console.log(`Error while getting outlet details: ${e}`);
      }
    };
  
    if (outletId) {
      fetchOutletDetails();
      userTractionCall(outletId);
    } else {
      const localData = localStorage.getItem("outletDetailsInfo");
      if (localData) {
        const parsed = JSON.parse(localData);
        setOutletDetails(parsed);
        userTractionCall(parsed?.outletId);
      } else {
        console.warn("No outletId and no data in localStorage!");
      }
    }
  }, [outletId]);
  

  useEffect(() => {
    if(!isWalletUpdated){
      getWalletPoints();
      setIsWalletUpdated(true);
    }
    if(amtInput.current){
      amtInput.current.focus();
    }
  },[])

  const userTractionCall = async (selectedId) => {
    let EventNo = 6;
    let SelectedOutlet = selectedId;
    let IsPaybillPage = true;
    try {
      const response = await UserTraction({
        EventNo: EventNo,
        SelectedOutlet: SelectedOutlet,
        PayBillClick: IsPaybillPage
      });
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const getWalletPoints = async () => {
    try {
      const responseData = await GetWalletPointsAPI();
      setWalletPoints(responseData?.walletPoints);
      dispatch(walletAmount(responseData?.walletPoints));
    } catch (error) {
      console.log("wallet points---", error);
    }
  };

  const handleBack = () => {
    // navigate("/outlet-list");
    //navigate(-1);
    if(fromPage === "restaurantList"){
      navigate("/outlet-list")
    }else if(fromPage === "explore"){
      navigate("/outlet-detail")
    }else{
      navigate("/outlet-list")
    }
  };

  const handleChange = (value) => {
    // console.log(`Initial Value -> ${value}`)
    if(value === undefined || value === ''){
      setErrorMessage("Amount field can't be empty!!")
      clearTimeout(typingTimeout);
      return;
    }
    if(value <= 0){
      setErrorMessage("Amount shouldn't be less then 1!!")
      clearTimeout(typingTimeout);
      return;
    }
    if (!/^\d*$/.test(value)) {
      setErrorMessage("Please enter a valid amount!!");
      return;
    }
    setErrorMessage(""); // Clear error message
    setOfferDetail({}); // Reset the selected offer as an empty object

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(
      setTimeout(() => {
        handleNext(value);
      }, 2000)
    );
  };

  // const maxLengthCheck = (object) => {
  //   if (object.value.length > object.max.length)
  //     object.value = object.value.slice(0, object.max.length);
  // };

  const openOfferDetail = (offer) => {
    setModalOffer(offer);
    setIsOfferDetailOpen(true);
  }

  const handleOfferClose = () => {
    setIsOfferDetailOpen(false);
  };

  const getBestOffer = async (outletId, billAmount) => {
    setIsLoader(true)
    try{
      const res = await GetBestOffer(
        outletId,
        billAmount
      );
      setOfferDetail(res[0])
      setIsLoader(false)
      return res[0]
    }catch(e){
      setIsLoader(false)
      console.log("Best Offer API Error :",e)
    }
  }

  const handleNext = async (amount) => {
    if (amount === undefined  || amount === "") {
      console.log("Amount field is empty!!")
      return
    }

    let updatedOfferDetail = offerDetail;

    if (Object.keys(offerDetail).length === 0 || offerDetail?.couponId === 0 || offerDetail?.minOrderAmt > amount) {
      updatedOfferDetail = await getBestOffer(outletDetails?.outletId, amount);
      setOfferDetail(updatedOfferDetail)
    }

    if (amount) {
      // navigate("/break-up", { state: { payableAmount: payableAmount, offerDetail: offerDetail } }); //Old code
      if(updatedOfferDetail.minOrderAmt > amount){
        updatedOfferDetail = {}
      }
      localStorage.setItem("payableAmount", amount);
      navigate("/break-up", { state: { payableAmount: amount, offerDetail: updatedOfferDetail } });
    }
  };

  const exploreRestaurant = () => {
    navigate(pageUrl.OUTLET_DETAIL, {
      state: { outletId: outletDetails?.outletId},
    });
  };

  return (
    <>
    <div className="header-outer-section">
      <Header
        coin={walletPoints}
        onClick={handleBack}
        label={outletDetails?.outletName}
        location={outletDetails?.locality}
      />
    </div>
    <div className="bill-amount-page">
      {isLoader && <Loader />}
      <div className="offer-section">
        <RestoDetail 
          name={outletDetails?.outletName}
          locality={outletDetails?.locality}
          city={outletDetails?.city}
          avgPrice={outletDetails?.avgTowPrice}
          type={outletDetails?.type}
          address={outletDetails?.address}
          expBtn={true}
          onExploreClick={exploreRestaurant}
        />
        {outletDetails?.outletOffers?.map((offer, index) => (
          offer.couponId > 0?
          <OfferCard
            key={index}
            discountType={offer.discountType}
            offerAmt={offer.discountValue}
            offerText={offer.offerName}
            minOrderAmt={offer.minOrderAmt}
            offerSelected={false}
            onClick={()=>openOfferDetail(offer)}
          />
          : null
        ))}
      </div>
      <div className="bill-amount">
        <div className="bill-text">ENTER BILL AMOUNT</div>
        <div className="amountInputWrapper">
          <CurrencyInput
            ref={amtInput}
            className="amountInputField"
            prefix="&#8377;"
            placeholder="₹"
            maxLength={5}
            decimalsLimit={2}
            onValueChange={(value) => handleChange(value)}
          />
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        {/* <div className="related-text">Proceed to cart for all offers</div> */}
        <div className="related-text">You will be redirected automatically</div>
      </div>
      {isOfferDetailOpen && (
        <OfferPopUp
          isOpen={isOfferDetailOpen}
          handleModalClose={handleOfferClose}
          offerDetail= {modalOffer}
        />
      )}
    </div>
    </>
  );
};

export default BillAmount;
